<template>
  <div class="his">
    <Header class="get-header" titles="奖金历史"></Header>
    <div class="his-list">
      <div class="his-eve" v-for="item in list" :key="item.id">
        <div class="eve-header">
          <div class="header-title">{{item.title}}</div>
          <div class="header-money">{{item.award}}</div>
        </div>
        <div class="eve-min">{{item.create_time}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMoneyh } from '@/api/api/user'
import { Toast } from 'vant'
import Header from '@/components/header'
export default {
  data() {
    return {
      list: [], // 拿到存放的list
      page: 1,  // 页数
      more: true, // 是否加载一个控制，避免重复触发
      nomore: false,  // 已加载完，不再请求
      times: true // 触底加载完通知
    }
  },
  components: {
    Header
  },
  created(){
    this.getMoneyHis()
  },
  mounted() {
    window.addEventListener('scroll', this.onSrcoll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onSrcoll)
  },
  methods: {
    getMoneyHis() {
      getMoneyh(this.page).then(res => {
        console.log(res.data.data.list)
        if(res.data.errorCode == '0') {
          if(res.data.data.list.length < 10) {
            this.nomore = true
          }
          this.list = [...this.list, ...res.data.data.list]
        }
      })
    },
    onSrcoll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var getWindowHeight = document.documentElement.clientHeight || document.body.clientHeight
      var documentScrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      // console.log(scrollTop,getWindowHeight,documentScrollHeight)
      if (scrollTop + getWindowHeight === documentScrollHeight && this.nomore) {
        if(this.times) {
          Toast('没有更多数据了')
          this.times = false
          setTimeout(() => {
            this.times = true
          }, 60000)
        }
        return
      }

      if(scrollTop + getWindowHeight >= (documentScrollHeight-500)) {
        if(!this.more) return
        this.more = false
        if(this.nomore) return
        this.page += 1
        this.getMoneyHis()
        setTimeout(() => {
          this.more = true
        }, 500)
      }

    },
  }
}
</script>

<style lang="scss">
.his {
  min-height: 100%;
  background: #F6F6F4;
  padding-top: 44px;
  .get-header {
    position: fixed;
    top: 0;
    width: 100%;
  }
  .his-list {
    margin-top: 10px;
    padding-left: 14px;
    background-color: white;
    .his-eve {
      height: 80px;
      border-bottom: 1px solid #D8D8D8;
      .eve-header {
        display: flex;
        height: 35px;
        line-height: 21px;
        padding-top: 14px;
        padding-right: 15px;
        justify-content: space-between;
        .header-title {
          font-size: 15px;
        }
        .header-money {
          font-size: 15px;
          color: #BE0000;
          font-weight:700;
        }
      }
      .eve-min {
        padding-top: 9px;
        color: #999999;
      }
    }
  }
}
</style>